import { jwtDecode } from "jwt-decode";
import { getToken } from "../../function/token";

const DB_VERSION = 1;
let dbPromise = null;


function initDB() {
  if (!dbPromise) {
    let userid = jwtDecode(getToken());
    dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open('MediaCacheDB'+userid.id, DB_VERSION);
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        const stores = ["all","image", "video", "audio", "document"];

        stores.forEach(storeName => {
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName);
          }
        });
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  return dbPromise;
}


export async function saveMedia(file_type,sending_type,fileId,blob = null) {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction([file_type,'all'], "readwrite");
    const store = tx.objectStore(file_type);
    const storeAll = tx.objectStore('all');
    const key = sending_type + '=' + fileId;
    store.put(blob, key);
    storeAll.put({
      type: file_type,
      file_id: key,
    }, key);

    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
}

// ---------------------------
// Get Blob
// ---------------------------

export async function getAllData() {
    const db = await initDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction('all', "readonly");
      const store = tx.objectStore('all');
    
      const result = [];
      const request = store.openCursor();

      request.onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          result.push({
            key: cursor.key,
            value: cursor.value
          });
          cursor.continue();
        } else {
          resolve(result);
        }
      };
      request.onerror = () => reject(request.error);
    });
}


export async function getMedia(file_type,sending_type,fileId) {
  const db = await initDB();
  
  return new Promise((resolve, reject) => {
    const tx = db.transaction([file_type], "readonly");
    const store = tx.objectStore(file_type);

    const request = store.get(sending_type+'='+fileId);

    request.onsuccess = () => {
      const value = request.result;

      if (value === undefined) {
        // Key does NOT exist
        resolve({ exists: false, value: null });
      } else {
        // Key exists – now check if null or Blob
        resolve({ exists: true, value: value });
      }
    };

    request.onerror = () => reject(request.error);
  });
}


export async function getMediafixtid(file_type,fileId) {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction([file_type], "readonly");
    const store = tx.objectStore(file_type);
    const request = store.get(fileId);

    request.onsuccess = () => {
      const value = request.result;

      if (value === undefined) {
        resolve({ exists: false, value: null });
      } else {
        // Key exists – now check if null or Blob
        resolve({ exists: true, value: value });
      }
    };

    request.onerror = () => reject(request.error);
  });
}
